import {SDrawerOrModal} from "shj-components";
import {useEffect, useState} from "react";
import config from "@/config";

export const ViewMeasureReport = (props) => {
  const {open, onClose, record} = props

  const [pageUrl, setPageUrl] = useState('')

  useEffect(() => {
    if(open) {
      record.id && onView()
      console.log(record)
    }
    return () => {
      setPageUrl('')
    }
  }, [open, record]);

  const onView = () => {
    const originUrl =  config.smallProgramUrl
    console.log(originUrl)
    try {
      const sourceURLDevice = record.isLr ? 'langrun' : 'shj';
      const STORAGE_TENANT = localStorage.getItem('X-Transfer-Inside-Tenant-Id')
      const pathUrl = `${originUrl}/pages/bannerAdvertisingPage/measureRoomReport?id=${record.id}&tenantId=${record.tenantId}&STORAGE_TENANT=${STORAGE_TENANT}&sourceURLDevice=${sourceURLDevice}&pageType=H5`
      setPageUrl(pathUrl)
    } catch (e) {
      console.log(e)
    }
  }

  return <SDrawerOrModal
      mode={'modal'}
      width={425}
      title={'量房报告'}
      open={open}
      onCancel={onClose}
      antdProps={{footer: []}}
  >
    {pageUrl && <iframe src={pageUrl} style={{width: 375, height: 600, border: 'none'}}/>}
  </SDrawerOrModal>
}